import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useUserStore } from "../store/user";
import { BackgroundFx } from "./BackgroundFx";

export function Layout() {
  const user = useUserStore((s) => s.user);
  const logout = useUserStore((s) => s.logout);
  const navigate = useNavigate();
  const location = useLocation();
  const onMenu = location.pathname === "/";

  return (
    <div className="min-h-screen flex flex-col relative">
      <BackgroundFx />

      {!onMenu && (
        <motion.div
          initial={{ opacity: 0, x: -8 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed top-4 left-4 z-30"
        >
          <Link
            to="/"
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full glass-soft text-sm text-ink-300 hover:text-ink-100 transition"
          >
            <span aria-hidden>←</span>
            <span>menu</span>
          </Link>
        </motion.div>
      )}

      <motion.div
        initial={{ opacity: 0, x: 8 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.25 }}
        className="fixed top-4 right-4 z-30 text-sm"
      >
        {user && !user.isGuest ? (
          <button
            onClick={async () => {
              await logout();
              navigate("/");
            }}
            className="px-3 py-1.5 rounded-full glass-soft text-ink-300 hover:text-ink-100 transition"
            title="log out"
          >
            {user.displayName ?? user.email}
          </button>
        ) : (
          <Link
            to="/login"
            className="px-3 py-1.5 rounded-full glass-soft text-ink-300 hover:text-ink-100 transition"
          >
            log in
          </Link>
        )}
      </motion.div>

      <main className="flex-1 max-w-3xl w-full mx-auto px-5 pt-20 pb-12">
        <Outlet />
      </main>
    </div>
  );
}
